import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sucesstemp',
  templateUrl: './sucesstemp.component.html',
  styleUrls: ['./sucesstemp.component.css']
})
export class SucesstempComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SucesstempComponent>,
    public router: Router
  ) { }

  ngOnInit() { }

  onYesClick(): void {
    this.dialogRef.close(true);
    this.router.navigateByUrl('/login')
  }

}
